import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: "relative",
      height: 40,
    },

    hiddenInput: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 500,

      "& input": {
        width: "100%",
        height: "100%",
        border: "none",
        outline: 0,
      },
    },

    pinWrapper: {
      position: "absolute",
      top: 0,
      left: 0,

      width: "100%",
      height: "100%",
      zIndex: 600,
      backgroundColor: theme.palette.common.white,

      "& .pinDot": {
        display: "inline-block",
        width: 14,
        height: 14,
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: 20,
        backgroundColor: theme.palette.common.white,

        "&.selected": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
    },
  }),
  { name: "input-pin-style", flip: null }
);
